import React, { useCallback, useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import Step1PersonalDetails from "./Step1PersonalDetails";
import Step2EmploymentDetails from "./Step2EmploymentDetails";
import Step3AddressAndContactDetails from "./Step3AddressAndContactDetails";
import Step5BankingDetails from "./Step5BankingDetails";
import Step6SalaryStructure from "./Step6SalaryStructure";
import { getEmployeeById } from "../../api/employeeApi";

const EmployeeFormContainer = () => {
   const { id } = useParams();
  const [step, setStep] = useState(1);
  let username = sessionStorage.getItem("username");

  const [formData, setFormData] = useState({
    employeeCode: "",
    designationID: 0,
    departmentID: 0,
    educationID: 0,
    gradeId: 0,
    sectionID: 0,
    fName: "",
    mName: "",
    lName: "",
    nameOnAadharCard: "",
    gender: "",
    maritalStatus: "",
    birthDate: "",
    age: 0,
    bloodGroup: "",
    empPassword: "",
    permanentAddress: "",
    presentAddress: "",
    country: "",
    state: "",
    district: "",
    taluka: "",
    city: "",
    pincode: "",
    phoneNo1: "",
    phoneNo2: "",
    emailId: "",
    aadharCardNumber: "",
    panNo: "",
    drivingLicNo: "",
    passportNo: "",
    joiningDate: "",
    retirementDate: null,
    employeeType: "",
    bankAccountNo: "",
    ifscCode: "",
    pfAccountNo: "",
    uanNo: "",
    esicNo: "",
    gratuityNo: "",
    mlwfLinNo: "",
    exitDate: null,
    reJoiningDate: null,
    previousExperience: "",
    basicSalary: 0,
    perDaySalary: 0,
    grossSalary: 0,
    totalAllow: 0,
    totalDeduction: 0,
    netSalary: 0,
    calculatePT: "Y",
    calculatePF: "Y",
    hraCalculation: "Y",
    calculateESIC: "Y",
    crUser: username || "Unknown",
    crDate: new Date().toISOString(),
    trUser: null,
    trDate: null,
    deleted: "N",


    allowance: {
      allowance1: 0,
      allowance2: 0,
      allowance3: 0,
      allowance4: 0,
      allowance5: 0,
      allowance6: 0,
      allowance7: 0,
      allowance8: 0,
      allowance9: 0,
      allowance10: 0,
      allowance11: 0,
      allowance12: 0,
      allowance13: 0,
      allowance14: 0,
      allowance15: 0,
      totalAllowance: 0
    },

  deduction: {
      deduction1: 0,
      deduction2: 0,
      deduction3: 0,
      deduction4: 0,
      deduction5: 0,
      deduction6: 0,
      deduction7: 0,
      deduction8: 0,
      deduction9: 0,
      deduction10: 0,
      deduction11: 0,
      deduction12: 0,
      deduction13: 0,
      deduction14: 0,
      deduction15: 0,
      totalDeduction1: 0
    },
  familyDetails: {
      fatherHusbandName: "",
      fatherHusbandDOB: null,
      fatherHusbandRelation: "",
      motherWifeName: "",
      motherWifeDOB: null,
      motherWifeRelation: "",
      child1Name: "",
      child1DOB: null,
      child1Gender: "",
      child2Name: "",
      child2DOB: null,
      child2Gender: ""
    }
  });

  useEffect(() => {
  if (id) {
    getEmployeeById(id)
      .then((data) => {
        const formatDate = (dateStr) => dateStr ? dateStr.split('T')[0] : "";
        const trimStr = (str) => typeof str === "string" ? str.trim() : str;

        setFormData({
          ...data,
          birthDate: formatDate(data.birthDate),
          joiningDate: formatDate(data.joiningDate),
          retirementDate: formatDate(data.retirementDate),
          reJoiningDate: formatDate(data.reJoiningDate),
          exitDate: formatDate(data.exitDate),

          familyDetails: {
            ...data.familyDetails,
            fatherHusbandDOB: formatDate(data.familyDetails?.fatherHusbandDOB),
            motherWifeDOB: formatDate(data.familyDetails?.motherWifeDOB),
            child1DOB: formatDate(data.familyDetails?.child1DOB),
            child2DOB: formatDate(data.familyDetails?.child2DOB),
            child1Gender: trimStr(data.familyDetails?.child1Gender),
            child2Gender: trimStr(data.familyDetails?.child2Gender)
          }
        });
      })
      .catch(console.error);
  }
}, [id]);



  const nextStep = () => setStep(prev => prev + 1);
  const prevStep = () => setStep(prev => prev - 1);
  
  const handleChange = useCallback((key, nestedKey) => (e) => {
    if (nestedKey) {
      setFormData(prev => ({
        ...prev,
        [key]: {
          ...prev[key],
          [nestedKey]: e.target.value,
        }
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [key]: e.target.value,
      }));
    }
  }, []);


  switch (step) {
    case 1:
      return (
        <Step1PersonalDetails
          formData={formData}
          handleChange={handleChange}
          nextStep={nextStep}
        />
      );
    case 2:
      return (
        <Step2EmploymentDetails
          formData={formData}
          handleChange={handleChange}
          nextStep={nextStep}
          prevStep={prevStep}
        />
      );
    case 3:
      return (
        <Step3AddressAndContactDetails
          formData={formData}
          handleChange={handleChange}
          nextStep={nextStep}
          prevStep={prevStep}
        />
      );
    case 4:
      return (
        <Step6SalaryStructure
          formData={formData}
          handleChange={handleChange}
          nextStep={nextStep}
          prevStep={prevStep}
        />
      );
        
      case 5:
        return (
        <Step5BankingDetails
          formData={formData}
          handleChange={handleChange}
          nextStep={nextStep}
          prevStep={prevStep}
        />
      );
      
    default:
      return null;
  }
};

export default EmployeeFormContainer;






//   useEffect(() => {
//   if (id) {
//     getEmployeeById(id)
//       .then((data) => {
//         // Convert date fields to "yyyy-MM-dd"
//         const formatDate = (dateStr) => dateStr ? dateStr.split('T')[0] : "";

//         setFormData({
//           ...data,
//           birthDate: formatDate(data.birthDate),
//           joiningDate: formatDate(data.joiningDate),
//           retirementDate: formatDate(data.retirementDate),
//           reJoiningDate: formatDate(data.reJoiningDate),
//           exitDate: formatDate(data.exitDate),
//           familyDetails: {
//             ...data.familyDetails,
//             fatherHusbandDOB: formatDate(data.familyDetails?.fatherHusbandDOB),
//             motherWifeDOB: formatDate(data.familyDetails?.motherWifeDOB),
//             child1DOB: formatDate(data.familyDetails?.child1DOB),
//             child2DOB: formatDate(data.familyDetails?.child2DOB)
//           }
//         });
//       })
//       .catch(console.error);
//   }
// }, [id]);

